import React, { useEffect, useRef, useState } from "react";
import { apiResponse } from "../../../../utils/apiResponse";
import { API_URL } from "../../../../utils/apiRoutes";
import ReactMarkdown from "react-markdown";
import { commonService } from "../../../../utils/commonService";
import userPlaceHolder from "../../../../Assets/Images/blank-user.svg";
import { useSelector } from "react-redux";
import botman from "../../../../Assets/Images/botgif.png";
import crossIcon from "../../../../Assets/Images/Action Icons/crossIcon.svg";
import fullScreenImg from "../../../../Assets/Images/Revenue-management/fullscreen.svg";
import minimizedImg from "../../../../Assets/Images/Revenue-management/minimized.svg";
import { apiCall } from "../../../../utils/axiosService";
import search from "../../../../Assets/Images/Glance Dashboard/search.svg";
import moment from "moment";
import { errorToastMessage } from "../../../../utils/toastMessage";
import { Link, useParams } from "react-router-dom";
import footerCalendar from "../../../../Assets/Images/Glance Dashboard/footerCalendar.svg";
import footerSetting from "../../../../Assets/Images/Glance Dashboard/footerSetting.svg";
import footerFlight from "../../../../Assets/Images/Glance Dashboard/footerFlight.svg";
import footerWeather from "../../../../Assets/Images/Glance Dashboard/footerWeather.svg";
import footerPdf from "../../../../Assets/Images/Glance Dashboard/footerPdf.svg";
const RMCopilot = () => {
    const { propertyId } = useParams();
    const searchPromptRef = useRef();
    const [showFullScreen, setShowFullScreen] = useState(false);
    let searchTerm = document.querySelector("#glanceDashboardChatSearch")?.value;
    const handleFullScreen = () => {
        setShowFullScreen(!showFullScreen);
    };
    const propertyDetailFromRTK = useSelector(
        (store) => store.headerProperty.propertyDetail
    );
    const [botData, setBotData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState("");
    const userDetail = commonService.getLoginUserData();
    const threadIdRef = useRef();
    const [showChat, setShowChat] = useState(false);
    const handleCloseChatModal = () => {
        setShowChat(false);
        setShowFullScreen(false);
    };

    const getThreadData = async () => {
        let HTMLData = document.getElementsByClassName("hdnSnapshotId");
        let data = [];
        if (HTMLData && HTMLData.length > 0) {
            if (HTMLData[0]?.value) {
                data = JSON.parse(HTMLData[0]?.value);
            }
        }
        let threadResponse = await apiCall(
            {
                method: "POST",
                url:
                    API_URL.BASE_API_URL.SnapShot +
                    API_URL.REVENUE_GLANCE.CREATE_THREAD_FOR_MODULE,
                body: {
                    propertyCode: propertyDetailFromRTK?.propertycode,
                    modulename: "rev_glance",
                    data: data,
                },
            },
            false
        );

        let response = apiResponse(false, threadResponse);

        if (response?.isValidate) {
            threadIdRef.current = response?.data?.data?.threadid;
        }

        if (!response?.isValidate) {
            threadIdRef.current = "";
            setLoading(false);
        }
    };

    const getBotData = async (msg) => {
        setLoading(true);
        await getThreadData();
        if (threadIdRef.current) {
            let botDataResponse = await apiCall(
                {
                    method: "POST",
                    url:
                        API_URL.BASE_API_URL.SnapShot +
                        API_URL.REVENUE_GLANCE.SEND_MSG_FOR_MODULE,
                    body: {
                        propertyCode: propertyDetailFromRTK?.propertycode,
                        modulename: "rev_glance",
                        threadid: threadIdRef.current,
                        message: msg,
                    },
                },
                false
            );

            let response = apiResponse(false, botDataResponse);

            if (response?.isValidate) {
                setBotData((prev) => [
                    ...prev,
                    { content: response?.data?.data?.message, role: "ai" },
                ]);
                setLoading(false);
            }

            if (!response?.isValidate) {
                setLoading(false);
            }
        }
    };

    let handleScroll = () => {
        let elemnet = document.getElementById("chatAreaDetails");
        if (elemnet) {
            elemnet.scrollTop = elemnet.scrollHeight;
        }
    };

    useEffect(() => {
        handleScroll();
    }, [botData]);

    useEffect(() => {
        if (searchTerm) {
            getBotData(searchTerm);
            setBotData((prev) => [...prev, { role: "user", content: searchTerm }]);
        }
    }, []);

    return (
        <>
            {showChat ? (
                <div
                    className={`chatModal ${showFullScreen ? "fullScrennChatModal" : ""}`}
                >
                    <div>
                        <div className="glanceChatHeader">
                            <div className="d-flex align-items-center gap-2">
                                <img src={botman} style={{ height: "30px" }} />
                                <p
                                    style={{
                                        color: "#4285f4",
                                        fontSize: "15px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    RM Copilot
                                </p>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <img id={commonService.generateGlobalClickTrackerID("RMCopilot", "minimizedimg", "")}
                                    src={minimizedImg}
                                    className="cursorPointer"
                                    style={{ height: "25px" }}
                                    onClick={() => {
                                        handleFullScreen();
                                    }}
                                />
                                <img id={commonService.generateGlobalClickTrackerID("RMCopilot", "fullscreenimg", "")}
                                    src={fullScreenImg}
                                    className="cursorPointer"
                                    style={{ height: "25px" }}
                                    onClick={() => {
                                        handleFullScreen();
                                    }}
                                />
                                <img id={commonService.generateGlobalClickTrackerID("RMCopilot", "crossicon", "")}
                                    src={crossIcon}
                                    className="cursorPointer"
                                    style={{ height: "25px" }}
                                    onClick={() => {
                                        handleCloseChatModal();
                                    }}
                                />
                            </div>
                        </div>
                        {/* <hr style={{ marginBottom: 0 }} /> */}
                        <div
                            id="chatAreaDetails"
                            className={`${showFullScreen ? "fullScreenChatAreaDetails" : ""}`}
                        >
                            {botData?.map((item) => {
                                return (
                                    <div
                                        className={`mt-3 ${item?.role === "user" ? "chatUser" : ""
                                            }`}
                                    >
                                        <div
                                            className={`chatBox ${item?.role === "user" ? "chatBoxUser" : ""
                                                }`}
                                        >
                                            <img
                                                src={
                                                    item?.role === "user"
                                                        ? userDetail?.profilepic
                                                            ? userDetail?.profilepic
                                                            : userPlaceHolder
                                                        : botman
                                                }
                                            />
                                            <div
                                                className={`${item?.role === "user" ? "userChatBox" : "aiChatBox"
                                                    }`}
                                            >
                                                <ReactMarkdown>
                                                    {item?.content?.replaceAll('"', "`")}
                                                </ReactMarkdown>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            {loading && <div>Loading...</div>}
                            {/* <div className="chat-inner-btns"></div> */}
                        </div>
                        <div className={"inputbox"}>
                            <input id={commonService.generateGlobalClickTrackerID("RMCopilot", "input-onchange", "")}
                                placeholder="Write a reply..."
                                className="w-100"
                                style={{
                                    padding: "10px 15px",
                                    borderRadius: "5px",
                                    boxShadow: "none",
                                }}
                                value={input}
                                onKeyDown={(e) => {
                                    if (e.keyCode === 13) {
                                        if (input) {
                                            getBotData(input);
                                            setBotData((prev) => [
                                                ...prev,
                                                { role: "user", content: input },
                                            ]);
                                            setInput("");
                                        }
                                    }
                                }}
                                onChange={(e) => {
                                    setInput(e.target.value);
                                }}
                            />
                            <button id={commonService.generateGlobalClickTrackerID("RMCopilot", "button-onclick", "")}
                                className="glance-send-btn"
                                onClick={() => {
                                    if (input) {
                                        getBotData(input);
                                        setBotData((prev) => [
                                            ...prev,
                                            { role: "user", content: input },
                                        ]);
                                        setInput("");
                                    }
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#3565FC"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="icon icon-tabler icons-tabler-outline icon-tabler-send"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M10 14l11 -11" />
                                    <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    style={{
                        width: "calc(100vw - 325px)",
                        backgroundColor: "#E1E8FF",
                        padding: "10px",
                        position: "fixed",
                        bottom: "0",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: "5px",
                        zIndex: "999999",
                    }}
                >
                    <div></div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            background: "white",
                            padding: "1px 5px",
                            borderRadius: "5px",
                            minWidth: "45vw",
                        }}
                    >
                        <img src={search} alt="Search" />

                        <input
                            style={{
                                border: "none",
                                outline: "none",
                                width: "360px",
                                maxWidth: "45vw",
                                fontSize: "16px",
                            }}
                            id="glanceDashboardChatSearch"
                            placeholder={`What is my ADR for the month of ${moment().format(
                                "MMMM YYYY"
                            )}`}
                            // value={searchPrompt}
                            onChange={(e) => {
                                let findElement = document.querySelector(
                                    "#glanceDashboardChatSearch"
                                );

                                searchPromptRef.current = e.target.value;
                                if (findElement) {
                                    if (e.target.value) {
                                        findElement.style.width = `${e.target.value?.length * 12
                                            }px`;
                                    } else {
                                        findElement.style.width = `360px`;
                                    }
                                    setInput(e.target.value);
                                }
                                // setSearchPrompt(e.target.value);
                            }}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                    // if (
                                    //   document.querySelector("#glanceDashboardChatSearch")
                                    //     ?.value === ""
                                    // ) {
                                    //   errorToastMessage("Please enter input");
                                    //   return;
                                    // }

                                    if (input) {
                                        getBotData(input);
                                        setBotData((prev) => [
                                            ...prev,
                                            { role: "user", content: input },
                                        ]);
                                        setInput("");
                                    }

                                    setShowChat(true);
                                }
                            }}
                        />
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Link id={commonService.generateGlobalClickTrackerID("RMCopilot", "link-link", "")} to={"/revenue/event"}>
                            <img src={footerCalendar} alt="Calendar" />
                        </Link>
                        <Link id={commonService.generateGlobalClickTrackerID("RMCopilot", "link-link", "")} to={`/revenue/property-setting/${propertyId}`}>
                            <img src={footerSetting} alt="Settings" />
                        </Link>
                        <Link id={commonService.generateGlobalClickTrackerID("RMCopilot", "link-link", "")} to={"/revenue/flight"}>
                            <img src={footerFlight} alt="Flight" />
                        </Link>
                        {/*<Link to={"/revenue/weather"}>*/}
                        {/*  <img src={footerWeather} alt="Weather" />*/}
                        {/*</Link>*/}
                        <Link id={commonService.generateGlobalClickTrackerID("RMCopilot", "link-link", "")}
                            to={`${document
                                ?.querySelector("[stranalysis]")
                                ?.getAttribute("href")}`}
                        >
                            <img src={footerPdf} alt="PDF" />
                        </Link>
                    </div>
                </div>
            )}
        </>
    );
};

export default RMCopilot;
